(function (win) {
  'use strict';
  if (!win || !win.document || !win.UnoGiftCapCore) return;

  const giftVariantIds = new Set(Object.values(win.UnoGiftCapCore.WRAPPER || {}).map(Number));
  let queued = false;

  function copy() {
    const isArabic = (win.document.documentElement.lang || '').toLowerCase().startsWith('ar');
    return {
      gift: isArabic ? 'هدية مجانية' : 'Free Gift',
      quantity: isArabic ? 'الكمية' : 'Qty',
    };
  }

  function lockGiftControls(row, quantityCell) {
    const popover = quantityCell?.querySelector('quantity-popover');
    if (popover) {
      popover.hidden = true;
      popover.setAttribute('aria-hidden', 'true');
      popover.style.setProperty('display', 'none', 'important');
    }

    const removeButton = row.querySelector('cart-remove-button');
    if (removeButton) {
      removeButton.hidden = true;
      removeButton.setAttribute('aria-hidden', 'true');
      removeButton.style.setProperty('display', 'none', 'important');
    }
  }

  function annotateRow(row) {
    const input = row.querySelector('[data-quantity-variant-id]');
    const variantId = Number(input?.dataset.quantityVariantId || 0);
    if (!giftVariantIds.has(variantId)) return;

    row.classList.add('uno-gc4-gift-line');
    const labels = copy();
    const qty = Math.max(0, Number(input?.value || input?.getAttribute?.('value') || 0));

    const titleLink = row.querySelector('.cart-item__name');
    if (titleLink) {
      titleLink.removeAttribute('href');
      titleLink.setAttribute('aria-disabled', 'true');
      titleLink.setAttribute('tabindex', '-1');
    }

    const quantityCell = row.querySelector('.cart-item__quantity');
    lockGiftControls(row, quantityCell);

    if (quantityCell) {
      let badge = quantityCell.querySelector('[data-uno-gc4-gift-qty]');
      if (!badge) {
        badge = win.document.createElement('span');
        badge.className = 'uno-gc4-gift-qty product-option';
        badge.setAttribute('data-uno-gc4-gift-qty', '');
        quantityCell.appendChild(badge);
      }
      const nextText = `${labels.quantity}: ${qty}`;
      if (badge.textContent !== nextText) badge.textContent = nextText;
    }

    const details = row.querySelector('.cart-item__details');
    if (details && !details.querySelector('[data-uno-gc4-gift-badge]')) {
      const badge = win.document.createElement('p');
      badge.className = 'uno-gc4-gift-badge product-option';
      badge.setAttribute('data-uno-gc4-gift-badge', '');
      if (badge.textContent !== labels.gift) badge.textContent = labels.gift;
      details.appendChild(badge);
    }
  }

  function annotate() {
    queued = false;
    win.document.querySelectorAll('.cart-item').forEach(annotateRow);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    queueMicrotask(annotate);
  }

  function boot() {
    annotate();
    if (!win.document.body) return;
    const observer = new MutationObserver(schedule);
    observer.observe(win.document.body, { childList: true, subtree: true });
  }

  if (win.document.readyState === 'loading') {
    win.document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})(typeof window !== 'undefined' ? window : null);
